import NotesIcon from '@mui/icons-material/Notes';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

NoteIcon.propTypes = {
  row: PropTypes.object,
};

export default function NoteIcon({ row }) {
  return (
    <div>
      <Tooltip title={row?.comments?.length ? `Note: ${row.comments.map(c => c, ", ")}` : 'No Note'} disableHoverListener={row?.deleted === true}>
        <IconButton disableRipple edge="end">
          <NotesIcon sx={{ ml: 0.5, fontSize: '1.00rem' }} color={row?.comments?.length > 0 ? "info" : "grey"} />
        </IconButton>
      </Tooltip>
    </div>
  );
}
